import { render, staticRenderFns } from "./DeleteProjectTemplate.vue?vue&type=template&id=33cada16&"
import script from "./DeleteProjectTemplate.vue?vue&type=script&lang=js&"
export * from "./DeleteProjectTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports